// Business data for Mehdi Soap Center
export const BUSINESS = {
  name: "Mehdi Soap Center",
  tagline: "Bharosemand Since 1971",
  founder: "Mehdi Hasan",
  operatedBy: "Allauddin Mehdi Hasan Khan",
  phone: "+91 98903 61979",
  phoneRaw: "919890361979",
  whatsappMessage: "Hello Mehdi Soap Center, mujhe products ke baare mein jaankari chahiye.",
};

export const waLink = (msg) =>
  `https://wa.me/${BUSINESS.phoneRaw}?text=${encodeURIComponent(msg || BUSINESS.whatsappMessage)}`;

export const telLink = `tel:${BUSINESS.phone.replace(/\s+/g, "")}`;

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Handmade Soaps", href: "#handmade" },
  { label: "Products", href: "#products" },
  { label: "Wholesale", href: "#wholesale" },
  { label: "Locations", href: "#locations" },
  { label: "Contact", href: "#contact" },
];

export const TRUST_STATS = [
  { number: "54+", label: "Saal ka Bharosa", sub: "Since 1971" },
  { number: "100%", label: "Locally Made", sub: "In-house manufactured" },
  { number: "0%", label: "Plastic", sub: "100% Eco-friendly cotton bags" },
  { number: "1000+", label: "Happy Customers", sub: "Retail + Wholesale" },
];

export const HANDMADE_SOAPS = [
  {
    name: "Kala Sabun",
    use: "Bartan ke liye sabse powerful — heavy oil, jali kadhai, sab saaf.",
    color: "#451A03",
    textColor: "#FFFFFF",
    badge: "Best for Utensils",
  },
  {
    name: "Peela Sabun",
    use: "Kapdon ka daag aur grease nikaalne ke liye, mehnati haath wala sabun.",
    color: "#D97706",
    textColor: "#FFFFFF",
    badge: "Tough Stains",
  },
  {
    name: "Hara Sabun",
    use: "Daily washing ke liye gentle — kapdon ko soft aur khushboodaar rakhe.",
    color: "#166534",
    textColor: "#FFFFFF",
    badge: "Daily Wash",
  },
  {
    name: "White Sabun",
    use: "Safed kapdon ke liye chamak laye, naazuk fabric ke liye safe.",
    color: "#F8FAFC",
    textColor: "#1F2937",
    badge: "For Whites",
  },
  {
    name: "Moam Sabun",
    use: "Bartan + kapde, dono ke liye — multi-purpose family favourite.",
    color: "#FBBF24",
    textColor: "#1F2937",
    badge: "2-in-1",
  },
];

export const CATEGORIES = [
  { name: "Branded Detergents", desc: "Ariel, Tide, Surf Excel & more at wholesale", icon: "Sparkles" },
  { name: "Bathing Soaps", desc: "Dove, Lux, Dettol, Pears, Santoor, etc.", icon: "Droplet" },
  { name: "Handmade Soaps", desc: "Hamari speciality (Kala, Peela, Hara)", icon: "Award" },
  { name: "Liquid Cleaners", desc: "Floor, glass, multi-surface", icon: "FlaskConical" },
  { name: "Handwash & Hygiene", desc: "All sizes & refills (Lifebuoy, Medimix)", icon: "HandPlatter" },
  { name: "Floor Cleaners", desc: "Phenyl, disinfectants, acid", icon: "Brush" },
  { name: "Utensil Cleaners", desc: "Bar, powder, liquid for tough stains", icon: "Utensils" },
  { name: "Cleaning Equipments", desc: "Jhaadu, kharata, pochha, wipers, mops", icon: "Wind" },
];

export const BRANDS = [
  "Ariel", "Tide", "Surf Excel", "Dettol", "Lifebuoy", "Godrej No.1", "Dyna", "Lux", "Dove", "Pears", "Medimix", "Margo", "Santoor"
];

export const BESTSELLERS = [
  { name: "Kala Sabun (Bartan)", note: "Handmade Speciality", price: "Contact for Price", imageKey: "handmade" },
  { name: "Mehdi Gold Super Plus", note: "Premium Bulk Powder", price: "Wholesale Rate", imageKey: "detergent" },
  { name: "Floor Phenyl 5L", note: "Strong fragrance", price: "Contact for Price", imageKey: "liquid" },
  { name: "Branded Bathing Soaps", note: "Wholesale Carton Box", price: "Bulk Available", imageKey: "soaps" },
];

export const LOCATIONS = [
  {
    title: "Mehdi Soap Center (Main)",
    address: "Quresh Nagar, Nizampur, Bhiwandi",
    timing: "Mon - Sat: 9:30 AM to 10:30 PM (Closed on Sunday)",
    namazBreak: "Friday Namaz Break: 1:00 PM to 4:00 PM",
    map: "https://www.google.com/maps/search/?api=1&query=Mehdi+Soap+Center+Nizampur+Bhiwandi",
    badge: "Main Branch",
  },
  {
    title: "Bombay Soap Center",
    address: "Gaibi Nagar, before Auliya Masjid, Bhiwandi",
    timing: "Mon - Sat: 9:00 AM to 2:00 PM, 5:00 PM to 10:00 PM",
    namazBreak: "Friday Namaz Break: 1:00 PM to 4:00 PM",
    map: "https://www.google.com/maps/search/?api=1&query=Bombay+Soap+Center+Gaibi+Nagar+Bhiwandi",
    badge: "Branch 2",
  },
  {
    title: "Mehdi Soap Center (Branch)",
    address: "Shanti Nagar, Bhaji Market, Bhiwandi",
    timing: "Mon - Sat: 9:00 AM to 9:00 PM",
    namazBreak: "Friday Namaz Break: 1:00 PM to 4:00 PM",
    map: "https://www.google.com/maps/search/?api=1&query=Mehdi+Soap+Center+Shanti+Nagar+Market+Bhiwandi",
    badge: "Branch 3",
  },
];

export const TESTIMONIALS = [
  {
    name: "Mohammad Tariq",
    place: "Bhiwandi",
    text: "Yeh dukaan sach mein kaafi purani aur bharosemand hai — lagbhag 50+ saalon se chal rahi hai. Yahan zyadatar items khud ke manufactured hote hain, isliye quality pe pura control rehta hai aur rates bhi reasonable hote hain.",
  },
  {
    name: "Ayesha Shaikh",
    place: "Local Resident",
    text: "Dukaan ki sabse badi speciality hai kacche sabun — jaise kala, peela aur white sabun, jo bina packaging ke hote hain. Ye wahi purane zamane ke natural sabun hain jo bartan aur kapde dhone ke liye best hain. Mere ghar wale 25+ saalon se yahin se samaan le rahe hain.",
  },
  {
    name: "Raju Kirana Store",
    place: "Shanti Nagar",
    text: "Owner aur staff dono hi bohot acche, cooperative aur honest hain. Yahan plastic ban hai! Aap apna bag la sakte ho ya sirf ₹5 mein carry bag mil jaata hai. Yeh ek hidden gem shop hai safai ke samaan ke liye.",
  },
];

export const IMAGES = {
  hero: "/images/broad-shop.jpg",
  handmade: "/images/kala-peela-lineup.jpg",
  wholesale: "/images/broad-shop.jpg",
  liquid: "/images/phenyl-can.png",
  soaps: "/images/wholesale-soaps.png",
  detergent: "/images/mehdi-detergent.png",
};